var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('custom-scroll',{staticClass:"box catalogs-panel",staticStyle:{"max-height":"inherit"}},[_c('a',{on:{"click":_vm.turnOffAllLayers}},[_vm._v("Скрыть все слои")]),_c('catalogs-tree',{attrs:{"root":_vm.rootCatalog}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }